<template>
    <BaseModal :width="600" title="创建 / 修改水印组" v-model="show">
        <a-row :gutter="10" class="images">
            <a-col span="4" v-if="!fullItems">
                <ImageUpload :height="83" :width="83" @input="addConfig" title="添加水印"/>
            </a-col>
            <a-col :class="{active: index === activeIndex}"
                   :key="index" @click="activeIndex = index"
                   span="4" v-for="(cfg, index) in watermark.config.items">
                <ResourceImg :id="cfg.resource" resize="m_7,w_100,h_100" width="100%"/>
                <a-popconfirm @confirm="delConfig(index)" placement="bottom" title="确认删除水印吗？">
                    <a-icon type="close"/>
                </a-popconfirm>
            </a-col>
        </a-row>
        <div :style="previewStyle" class="preview">
            <VueDraggableResizable
                :class="{active: activeIndex === index}" :draggable="activeIndex === index"
                :h="getHeight(index)" :key="index"
                :parent="true" :resizable="false" :w="getWidth(index)"
                :x="getAxisX(index)" :y="getAxisY(index)" :z="activeIndex === index ? 2 : 1" @activated="activeIndex = index"
                @dragstop="onDragged" style="position: absolute;" v-for="(cfg, index) in watermark.config.items">
                <ResourceImg :id="cfg.resource" :rotate="cfg.rotate" :transparent="cfg.transparent"/>
            </VueDraggableResizable>
        </div>
        <FormModel :action="submit" :disabled="noItems" :label-col="{span: 2}"
                   :model="activeConfig" :wrapper-col="{span: 22}" labelAlign="left" v-on="$listeners">
            <a-form-model-item label="尺寸">
                <a-slider :disabled="noItems" :max="100" :min="5" :step="5" @change="refreshAxis" v-model="activeConfig.size_percent"/>
            </a-form-model-item>
            <a-form-model-item label="透明">
                <a-slider :disabled="noItems" :max="100" :min="5" :step="5" v-model="activeConfig.transparent"/>
            </a-form-model-item>
            <a-form-model-item label="旋转">
                <a-slider :disabled="noItems" :max="360" :min="0" :step="1" v-model="activeConfig.rotate"/>
            </a-form-model-item>
        </FormModel>
    </BaseModal>
</template>

<script>
    import api from "../../../../../utils/api";
    import func from "../../../../../utils/func";
    import ResourceImg from "../../../../../comps/ResourceImg";
    import ImageUpload from "../../../../../comps/ImageUpload";
    import VueDraggableResizable from 'vue-draggable-resizable';
    import BaseModal from "../../../../../comps/BaseModal";
    import FormModel from "../../../../../comps/FormModel";

    export default {
        name: "WatermarkForm",
        components: {FormModel, BaseModal, ImageUpload, ResourceImg, VueDraggableResizable},
        props: {
            album: Object,
            preview: Object,
        },
        data() {
            return {
                show: false,
                watermark: {
                    id: "",
                    config: {
                        items: [],
                        weight: 100,
                    }
                },
                activeIndex: 0,
            }
        },
        computed: {
            noItems() {
                return this.watermark.config.items.length === 0;
            },
            fullItems() {
                return this.watermark.config.items.length === 6;
            },
            activeConfig() {
                return this.watermark.config.items.length
                    ? this.watermark.config.items[this.activeIndex]
                    : {rotate: 0, size_percent: 0, transparent: 0};
            },
            previewStyle() {
                let url = api.v1.resource.watermarkPreview(0);
                return `background:url(${url});width:${this.preview.width}px;height:${this.preview.height}px`;
            },
            previewPercent() {
                return this.preview.width / this.preview.height;
            }
        },
        methods: {
            open(watermark) {
                this.show = true;
                if (func.isDefined(watermark)) {
                    this.watermark = func.copyObject(watermark);
                } else {
                    this.watermark = {id: "", config: {items: [], weight: 100}}
                }
            },
            getItem(index) {
                return this.watermark.config.items[index];
            },
            getWidth(index) {
                let it = this.getItem(index);
                let size = it.wh_ratio >= this.previewPercent
                    ? this.preview.width : (this.preview.height * it.wh_ratio);
                return it.size_percent * size / 100;
            },
            getHeight(index) {
                let it = this.getItem(index);
                let size = it.wh_ratio >= this.previewPercent
                    ? (this.preview.width / it.wh_ratio) : this.preview.height;
                return it.size_percent * size / 100;
            },
            getAxisX(index) {
                return this.getItem(index).axis_x[0] * this.preview.width;
            },
            getAxisY(index) {
                return this.getItem(index).axis_y[0] * this.preview.height;
            },
            onDragged(x, y) {
                this.activeConfig.axis_x = [
                    Math.min(1, x / this.preview.width),
                    Math.min(1, (x + this.getWidth(this.activeIndex)) / this.preview.width),
                ];
                this.activeConfig.axis_y = [
                    Math.min(1, y / this.preview.height),
                    Math.min(1, (y + this.getHeight(this.activeIndex)) / this.preview.height)
                ];
            },
            refreshAxis() {
                let w = this.getWidth(this.activeIndex);
                let h = this.getHeight(this.activeIndex);
                let x = this.getAxisX(this.activeIndex);
                let y = this.getAxisY(this.activeIndex);
                if ((x + w > this.preview.width) || (y + h) > this.preview.height) {
                    this.onDragged(Math.min(x, this.preview.width - w), Math.min(y, this.preview.height - h))
                }
            },
            addConfig(id) {
                func.imageSize(func.imageUrl(id)).then(size => {
                    this.watermark.config.items.push({
                        resource: id, axis_x: [], axis_y: [], rotate: 0,
                        size_percent: 100, transparent: 100, wh_ratio: size.w / size.h
                    });
                    this.activeIndex = this.watermark.config.items.length - 1;
                    this.onDragged(0, 0); // 初始化在0点
                });
            },
            delConfig(index) {
                this.watermark.config.items.splice(index, 1);
                this.activeIndex = Math.min(this.watermark.config.items.length - 1, index);
            },
            submit() {
                let promise = this.watermark.id
                    ? api.v1.album.watermark.update(this.album.id, this.watermark.id, this.watermark.config)
                    : api.v1.album.watermark.create(this.album.id, this.watermark.config);
                return promise.then(() => this.show = false);
            }
        }
    }
</script>

<style lang="less" scoped>
    .images {
        img {
            width: 100%;
            padding: 5px;
            border-radius: 5px;
            cursor: pointer;
            border: 1px #e8e8e8 solid;
            position: relative;
        }

        .anticon {
            top: -8px;
            right: -2px;
            padding: 2px;
            border-radius: 100%;
            position: absolute;
            color: #ffffff;
            background: #ff5500;
            display: none;
        }

        .active {
            img {
                border-color: #ff5500;
            }

            .anticon {
                display: block;
            }
        }
    }

    .preview {
        overflow: hidden;
        margin: 15px 0;
        position: relative;

        .vdr {
            cursor: pointer;
            border: 1px transparent solid;

            img {
                width: 100%;
                height: 100%;
            }
        }

        .active {
            border-color: #ff5500;
        }
    }

    .ant-form-item {
        margin-bottom: 0;
    }
</style>
